import { NEW_USER, OWN_DATA_RECEIVED } from "../actions/chatAction";

const initialState = {
	byIds: {
		bot: {
			id: 'bot',
			name: 'Bot',
			// avatarUrl:'https://static.staging.livechatinc.com/1520/P10064EDGF/7970c9d036275c2ee9282d15535ef57b/botengine-avatar.png',
		},
	},
	ownId: null,
	currentAgent: 'bot',
};

export default function(state = initialState, action) {
    switch(action.type) {
        case NEW_USER:
            return {
                ...state,
                currentAgent: action.payload.name,
                byIds: {
                    ...state.byIds,
                    [action.payload.id]: action.payload,
                },
            };
        case OWN_DATA_RECEIVED:
            return {
                ...state,
                ownId: action.payload.id,
                byIds: {
                    ...state.byIds,
                    [action.payload.id]: {
                        ...action.payload,
                        name: 'Client',
                    },
                },
            };
        default:
            return state;
    }
}

export const getUsers = state => state.users.byIds;
export const getOwnId = state => state.users.ownId;
export const getCurrentAgent = state => state.users.currentAgent;